import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export interface PublicDeviceFilterState {
  search: string;
  sortBy: 'name' | 'recent' | 'location';
}

interface PublicDeviceFiltersProps {
  filters: PublicDeviceFilterState;
  onFiltersChange: (filters: PublicDeviceFilterState) => void;
}

export const PublicDeviceFilters = ({ filters, onFiltersChange }: PublicDeviceFiltersProps) => {
  return (
    <div className="showcase-filters flex flex-col sm:flex-row gap-4 mb-6">
      {/* Search */}
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Search cameras..."
          value={filters.search}
          onChange={(e) => onFiltersChange({ ...filters, search: e.target.value })}
          className="pl-9"
        />
      </div>

      {/* Sort By */}
      <Select
        value={filters.sortBy}
        onValueChange={(value: 'name' | 'recent' | 'location') =>
          onFiltersChange({ ...filters, sortBy: value })
        }
      >
        <SelectTrigger className="w-full sm:w-[180px]">
          <SelectValue placeholder="Sort by" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="name">Name (A-Z)</SelectItem>
          <SelectItem value="recent">Most Recent</SelectItem>
          <SelectItem value="location">Location</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
